/* ===========================================================================
   Produktseite – Variantenauswahl, Menge, Galerie
   ---------------------------------------------------------------------------
   Ohne JavaScript bleibt die Seite kaufbar: das Formular ist ein normales
   Shopify-Produktformular, die zuerst gewaehlte Variante ist vorbelegt.
   Dieses Skript verbessert nur die Bedienung.
   =========================================================================== */

(function () {
  'use strict';

  function initProduct(root) {
    var form = (root || document).querySelector('[data-product-form]');
    if (!form || form.dataset.bound === 'true') return;
    form.dataset.bound = 'true';

    var wrapper = form.closest('[data-product]');
    var dataEl = wrapper.querySelector('[data-variant-data]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = form.querySelector('[data-variant-id]');
    var selects = [].slice.call(wrapper.querySelectorAll('[data-option-index]'));
    var priceEl = wrapper.querySelector('[data-price]');
    var compareEl = wrapper.querySelector('[data-compare-price]');
    var saveEl = wrapper.querySelector('[data-savings]');
    var availEl = wrapper.querySelector('[data-availability]');
    var button = form.querySelector('[data-add-to-cart]');
    var buttonLabel = button ? button.querySelector('[data-add-label]') : null;
    var skuEl = wrapper.querySelector('[data-sku]');

    function gewaehlteWerte() {
      return selects.map(function (s) { return s.value; });
    }

    function findeVariante() {
      var werte = gewaehlteWerte();
      for (var i = 0; i < variants.length; i += 1) {
        var v = variants[i];
        var treffer = true;
        for (var k = 0; k < werte.length; k += 1) {
          if (v.options[k] !== werte[k]) { treffer = false; break; }
        }
        if (treffer) return v;
      }
      return null;
    }

    function setzeBild(mediaId) {
      if (!mediaId) return;
      var ziel = wrapper.querySelector('[data-gallery-item][data-media-id="' + mediaId + '"]');
      if (ziel) ziel.click();
    }

    function aktualisiere() {
      var v = findeVariante();

      if (!v) {
        if (idInput) idInput.value = '';
        if (button) {
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          if (buttonLabel) buttonLabel.textContent = button.dataset.labelUnavailable;
        }
        if (availEl) availEl.textContent = availEl.dataset.labelUnavailable;
        return;
      }

      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.innerHTML = v.price;
      if (compareEl) {
        compareEl.innerHTML = v.compare_at || '';
        compareEl.hidden = !v.compare_at;
      }
      if (saveEl) {
        saveEl.innerHTML = v.savings || '';
        saveEl.hidden = !v.savings;
      }
      if (skuEl) {
        skuEl.textContent = v.sku || '';
        skuEl.hidden = !v.sku;
      }
      if (availEl) {
        availEl.textContent = v.available ? availEl.dataset.labelAvailable : availEl.dataset.labelSoldOut;
        availEl.setAttribute('data-state', v.available ? 'available' : 'sold-out');
      }
      if (button) {
        button.disabled = !v.available;
        button.setAttribute('aria-disabled', v.available ? 'false' : 'true');
        if (buttonLabel) buttonLabel.textContent = v.available ? button.dataset.labelAdd : button.dataset.labelSoldOut;
      }
      setzeBild(v.media_id);

      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', aktualisiere); });
    if (selects.length) aktualisiere();

    /* --------------------------------- Menge -------------------------------- */
    var qty = wrapper.querySelector('[data-quantity-input]');
    wrapper.querySelectorAll('[data-quantity-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var schritt = Number(btn.dataset.quantityStep);
        var wert = Number(qty.value) + schritt;
        var min = Number(qty.min || 1);
        if (wert < min) wert = min;
        qty.value = wert;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    /* -------------------------------- Galerie -------------------------------
       Bilder verhalten sich unveraendert: das Hauptbild tauscht src, srcset
       und alt. Video, eingebettetes Video und 3D-Modell liegen als eigene
       Ebenen bereit und werden statt des Bildes eingeblendet. */
    var haupt = wrapper.querySelector('[data-gallery-main]');
    var medienEbenen = [].slice.call(wrapper.querySelectorAll('[data-gallery-media]'));

    function zeigeEbene(mediaId, typ) {
      medienEbenen.forEach(function (ebene) {
        var aktiv = typ !== 'image' && ebene.dataset.mediaId === String(mediaId);
        ebene.hidden = !aktiv;
        if (!aktiv) {
          var video = ebene.querySelector('video');
          if (video && typeof video.pause === 'function') video.pause();
        }
      });
      if (haupt) haupt.hidden = typ !== 'image';
    }

    wrapper.querySelectorAll('[data-gallery-item]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var typ = thumb.dataset.mediaType || 'image';
        var src = thumb.dataset.full;
        var srcset = thumb.dataset.fullSrcset;
        var alt = thumb.dataset.alt;
        if (typ === 'image' && haupt && src) {
          haupt.src = src;
          if (srcset) haupt.srcset = srcset;
          if (alt) haupt.alt = alt;
        }
        zeigeEbene(thumb.dataset.mediaId, typ);
        wrapper.querySelectorAll('[data-gallery-item]').forEach(function (t) {
          t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
        });
      });
    });
  }

  function init(root) { initProduct(root); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
